import { Component, Input, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as AppActions from 'src/app/state/app/app.actions';

@Component({
  selector: 'app-logout',
  template: '<div></div>',
  standalone: false
})

export class LogoutComponent {
  constructor(private store: Store) {
    this.store.dispatch(AppActions.logout());
  }
}
